import script from "./VersionHistoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionHistoryModal.vue?vue&type=script&setup=true&lang=js"

import "./VersionHistoryModal.vue?vue&type=style&index=0&id=277cf39a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-277cf39a"]])

export default __exports__